module.exports = __webpack_public_path__ + "img/homepage-behance.a9d24694.svg";